import dayjs from "dayjs";
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import commoncss from "../../css/common.module.css";
import buttoncss from "../../css/button.module.css";
import Modal from "../../elements/Modal";
import { truncateText } from "../../../../src/utils/mis";
import { Button } from "../../elements/Button";
import restoreTaskModalCss from "../../css/restoreTaskModal.module.css";
import DefaultUserRound from "../../assets/imgs/DefaultUserRound.png";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";



const RestoreTaskModal = ({
  handleClose,
  setRestoreTaskModal,
  restoreTaskIds,
  setRestoreTaskIds,
  RestoreTasks
}) => {

    const { bookClosureTasks } = useSelector((state) => state.BookClosureReducer);

    useEffect(() => {
        setRestoreTaskIds([]);
    }, [setRestoreTaskIds]);

    const handleToggleTask = (taskId) => {
        setRestoreTaskIds((prev) =>
            prev.includes(taskId)
            ? prev.filter((id) => id !== taskId)
            : [...prev, taskId]
        );
    };

    const handleToggleAll = (allIds) => {
        if (restoreTaskIds.length === allIds.length) {
            setRestoreTaskIds([]);
        } else {
            setRestoreTaskIds(allIds);
        }
    };

    return (
        <Modal
            title="Restore Deleted Items"
            bodycss={commoncss.unsetPadding}
            width="60%"
            minHeight="300px"
            headerActions={
                <CloseIcon
                onClick={() => {
                    handleClose();
                    setRestoreTaskModal(false);
                }}
                className="clickable"
                />
            }

            footerActions={
                <>
                    <Button
                        btnColor={buttoncss.secondary}
                        onClick={() => {
                            handleClose();
                            setRestoreTaskModal(false);
                        }}
                        label="Cancel"
                    />

                    <div style={{ display:"flex", alignItems:"center", gap:"20px" }}>
                        {restoreTaskIds.length > 0 && (
                            <span className={restoreTaskModalCss.importSelectedText}>
                                ({restoreTaskIds.length}) selected
                            </span>
                        )}
                        <Button
                            btnColor={buttoncss.primary}
                            label="Restore Selected Items"
                            onClick={RestoreTasks}
                            disabled={restoreTaskIds.length === 0}
                        />
                    </div>
                </>
            }
        >
            <div>
                <table className={restoreTaskModalCss.restoreTable}>
                    <thead>
                        <tr>
                            <th className={restoreTaskModalCss.checkboxTd}>
                                <input
                                    type="checkbox"
                                    className={restoreTaskModalCss.customCheckbox}
                                    checked={
                                        bookClosureTasks?.filter(t => t.deleted)?.length > 0 &&
                                        restoreTaskIds.length ===
                                            bookClosureTasks.filter(t => t.deleted).length
                                    }
                                    onChange={() =>
                                        handleToggleAll(
                                            bookClosureTasks
                                            .filter((task) => task.deleted)
                                            .map((task) => task._id) // or task.id
                                        )
                                    }
                                />
                            </th>
                            <th>Task Name</th>
                            <th>Module</th>
                            <th>Assignee</th>
                            <th>Approver</th>
                            <th>Due Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(bookClosureTasks?.filter(task => task.deleted === true).length > 0) ? (
                            bookClosureTasks
                            .filter(task => task.deleted === true) 
                            .map((task, index) => (
                            <React.Fragment key={index}>
                                <tr key={index}>
                                    <td className={restoreTaskModalCss.checkboxTd}>
                                        <input
                                            type="checkbox"
                                            className={restoreTaskModalCss.customCheckbox}
                                            checked={restoreTaskIds.includes(task._id)}
                                            onChange={() => handleToggleTask(task._id)}
                                        />
                                    </td>
                                    <td>{truncateText(task?.name, 5550)}</td>
                                    <td 
                                        style={{
                                            "text-transform": "uppercase",
                                            "font-weight": "600",
                                        }}
                                    >
                                        {task?.module}
                                    </td>
                                    <td>
                                        <div className={restoreTaskModalCss.bkclColumnWithImgCtn}>
                                            <div className="d-flex mb-1">
                                            {task.assigneeData.slice(0,2).map((assign, idx) => (
                                                <img
                                                key={idx}
                                                src={assign.profileImageUrl || DefaultUserRound}
                                                className={restoreTaskModalCss.bkclUserImg}
                                                style={{
                                                    marginLeft: idx === 0 ? "0px" : "-8px"
                                                }}
                                                />
                                            ))}
                                                {task.assigneeData.length > 2 && (
                                                <div className={restoreTaskModalCss.bkclImgCountCtn}>
                                                    {task.assigneeData.length - 2}+
                                                </div>
                                                )}
                                            </div>
                                            <div className={restoreTaskModalCss.userNameTruncate}>
                                            {task.assigneeData.map(assign => assign.name).join(", ")}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className={restoreTaskModalCss.bkclColumnWithImgCtn} style={{ gap:"0px" }}>
                                            {task.approverData && (
                                                <>
                                                <img
                                                    src={task.approverData.profileImageUrl || DefaultUserRound}
                                                    className={restoreTaskModalCss.bkclUserImg}
                                                    alt={task.approverData.name}
                                                />
                                                <span style={{ marginLeft: "6px" }}>{task.approverData.name}</span>
                                                </>
                                            )}
                                        </div>
                                    </td>
                                    <td>
                                        {task?.dueDate
                                        ? dayjs(task?.dueDate).format("DD-MMM-YYYY")
                                        : ""}
                                    </td>
                                </tr>
                            </React.Fragment>
                            ))
                        )
                        :(
                            <tr>
                                <td
                                colSpan={6}
                                className="text-secondary text-center font-size-16 custom-font-600 font-inter"
                                >
                                {" "}
                                No deleted tasks.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            


        </Modal>
    );
};

export default RestoreTaskModal;
